<template>
  <div>
    <div class="eventCheckin">
      <v-container>
        <v-layout>
          <v-flex xs12>
            <h1 class="mb-2"><span v-if="checkinType == 'network'">Network Memberships</span><span v-else>Event Check-in</span></h1>
            <v-select
              outline
              :items="displayEvents"
              item-value="id"
              :label="checkinType == 'network' ? 'Select a Network' : 'Select an Event'"
              @change="loadRegistrants"
              v-model="event"
              return-object
              :loading="eventsLoading"
              :menu-props="{contentClass: 'checkinSelector'}"
            >
              <template slot="selection" slot-scope="data">
                {{ data.item.name }}  ({{ data.item.dates }})
              </template>
              <template slot="item" slot-scope="data">
                {{ data.item.name }} ({{ data.item.dates }})
              </template>
            </v-select>

            <div v-if="eventLoaded" class='text-xs-right addSchoolButton'>
              <v-btn @click="exportRegistration" class="mx-0" flat outline><v-icon>cloud_download</v-icon>Export List to Excel</v-btn>
              <v-btn @click="addDistrictSchool(currentEventId)" class='mx-0' color='primary'><v-icon>add</v-icon>Add District/School to this &nbsp; <span v-if="checkinType == 'network'"> Network</span><span v-else> Event</span> </v-btn>
            </div>

            <v-data-table
              :headers="headers"
              :items="registrants"
              class="elevation-1 amaze-data-table"
              :pagination.sync="pagination"
              sort-icon="arrow_drop_down"
              v-if="eventLoaded"
            >

              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded">

                  <!-- Normal Headers Case -->
                  <td v-if="!useAltHeaders">{{ props.item.school }}</td>
                  <td v-if="!useAltHeaders">{{ props.item.district }}</td>
                  <td v-if="!useAltHeaders">
                    <template v-if="props.item.state">{{ props.item.state }}</template>
                    <template v-else><i>N/A</i></template>
                  </td>

                  <!-- Alt Headers Case -->
                  <td v-if="useAltHeaders">{{ props.item.district }}</td>
                  <td v-if="useAltHeaders">
                    <template v-if="props.item.school">{{ props.item.school }}</template>
                    <template v-else><i>N/A</i></template>
                  </td>

                  <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on">
                            <v-btn class="amaze-user-action" slot="activator" @click.stop="editSchool(props.item.id)" icon><v-icon>$vuetify.icons.amaze-edit</v-icon></v-btn>
                          </div>
                        </template>
                        <span>Edit School</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on">
                            <v-btn class="amaze-user-action" slot="activator" @click.stop="deleteSchool(props.item.id)" icon><v-icon>$vuetify.icons.amaze-delete</v-icon></v-btn>
                          </div>
                        </template>
                        <span>Delete School</span>
                      </v-tooltip>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props" class='elevation-1'>
                <div class="pa-3">
                <div v-for="(value, name) in props.item.extra_attributes" :key="value">
                  <p><b>{{ name }}</b>: <span v-html="showExtraValue(value)"></span></p>
                </div>

                <v-data-table
                  :headers="innerHeaders"
                  :items="props.item.registration_team_member"
                  sort-icon="arrow_drop_down"
                  dark
                  hide-actions
                >
                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props2">
                    <tr>
                      <td>{{ props2.item.name }}</td>
                      <td>{{ props2.item.email }}</td>
                      <td v-if="useAltHeaders">
                        <template v-if="props2.item.address">
                          // eslint-disable-next-line vue/require-v-for-key
                          // eslint-disable-next-line vue/require-v-for-key
                          <template v-for="line in props2.item.address.split('\n')">{{ line }}<br></template>
                        </template>
                      </td>
                      <td>{{ props2.item.role }}</td>
                      <td class='text-xs-center'>
                        <a v-if="!props2.item.terms && checkinType === 'network' && event.scope === 'ecs_sponsor' " target="_blank"><v-icon color="red">fas fa-times-circle</v-icon></a>
                        <v-icon v-else color="green">fas fa-check-circle</v-icon>
                      </td>
                      <td class='text-xs-center'>
                        <div v-if="props2.item.loading">
                          <v-icon>fas fa-circle-notch fa-spin</v-icon>
                        </div>
                        <div v-else>
                          <v-icon v-if="!props2.item.attended" @click="checkIn(props2.item)" color="grey darken-4">fas fa-check-circle</v-icon>
                          <v-icon v-else color="green">fas fa-check-circle</v-icon>
                        </div>
                      </td>
                      <td class="justify-center layout px-0">

                        <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on">
                            <v-btn class="amaze-user-action" slot="activator" @click.stop="editPerson(props.item.id, props2.item.id)" icon><v-icon>$vuetify.icons.amaze-edit</v-icon></v-btn>
                          </div>
                        </template>
                        <span>Edit Person</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on">
                            <v-btn class="amaze-user-action" slot="activator" @click="deletePerson(props.item.id, props2.item.id)" icon><v-icon>$vuetify.icons.amaze-delete</v-icon></v-btn>
                          </div>
                        </template>
                        <span>Delete Person</span>
                      </v-tooltip>

                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class='text-xs-right'>
                  <v-btn @click="addPerson(props.item.id)" class='mx-0' color='primary'><v-icon>add</v-icon> Add Person to this Registration</v-btn>
                </div>
                </div>
              </template>
            </v-data-table>
            <!-- <v-btn @click="addSchool()" class='ml-0'><v-icon>fas fas-plus</v-icon> Add School</v-btn> -->
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-dialog v-model="schoolDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Manage District/School</span>
        </v-card-title>

        <v-card-text>
          <v-text-field v-model="editedSchool.district" label="District"></v-text-field>
          <v-text-field v-model="editedSchool.school" label="School"></v-text-field>
          <v-text-field v-if="!useAltHeaders" v-model="editedSchool.state" label="State"></v-text-field>
          <div class="extraAttributes registrationExtraAttributes">
            <AmazeExtraAttributesEditor
            :attributes="editedSchool.extra_attributes"
            ></AmazeExtraAttributesEditor>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="closeSchool" flat outline>Cancel</v-btn>
          <v-btn color="primary" @click="saveSchool">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="personDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Manage Person</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="managePersonForm">
            <v-text-field v-model="editedPerson.name" label="Name" :rules="rules.populated"></v-text-field>
            <v-text-field v-model="editedPerson.email" label="Email" :rules="rules.email"></v-text-field>
            <v-text-field v-model="editedPerson.phone" label="Phone"></v-text-field>
            <v-text-field v-if="useAltHeaders" v-model="editedPerson.address" label="Address"></v-text-field>
            <v-text-field v-model="editedPerson.role" label="Role" :rules="rules.populated"></v-text-field>
            <div class="extraAttributes registrantExtraAttributes" v-if="!addPersonMode">
              <AmazeExtraAttributesEditor
                :attributes="editedPerson.extra_attributes"
              ></AmazeExtraAttributesEditor>
          </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  @click="closePerson" flat outline>Cancel</v-btn>
          <v-btn color="primary" @click="savePerson">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="districtSchoolDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add District/School</span>
        </v-card-title>

        <v-form
          ref="districtSchoolForm"
        >
          <v-card-text>
            <v-text-field
              v-model="newDistrict"
              required
              :rules="rules.populated"
            >
              <template slot="label">District <i>(required)</i></template>
            </v-text-field>
            <v-text-field label="School" v-model="newSchool"></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDistrictSchool" flat outline>Cancel</v-btn>
            <v-btn color="primary" @click="saveDistrictSchool">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

  </div>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.eventCheckin {
  margin-top: 50px;
  min-height: 80vh;

  .dtable td{
    font-size: 16px;
  }

  .dtable .v-datatable__expand-content thead tr:hover{
    background: #616161 !important;
  }

  .addSchoolButton {
    margin-bottom: 10px;

    button {
      margin-left: 10px !important;

      .v-icon {
        margin-right: 6px;
      }
    }
  }
}
</style>

<script>
import Sugar from "sugar";
import AmazeExtraAttributesEditor from "@/components/Widgets/AmazeExtraAttributesEditor";

export default {
  components: {
    AmazeExtraAttributesEditor
  },
  data() {
    return {
      personDialog: false,
      schoolDialog: false,
      events: [],
      event: {},
      registrants: [],
      eventLoaded: false,
      eventsLoading: true,
      currentEventId: null,
      currentEventTitle: '',
      regHeaders: [
        { text: "School", value: "school" },
        { text: "District", value: "district" },
        { text: "State", value: "state" },
        { text: "", value: 'name', align: "center", sortable: false }
      ],
      regInnerHeaders: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Role", value: "role" },
        { text: "Terms?", value: "terms", align: "center", sortable: false },
        { text: "Check-in", value: "terms", align: "center", sortable: false },
        { text: "", value: 'name', align: "center", sortable: false }
      ],
      altHeaders: [
        { text: "District", value: "district" },
        { text: "School", value: "school" },
        { text: "", value: 'name', align: "center", sortable: false }
      ],
      altInnerHeaders: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Address", value: "address" },
        { text: "Role", value: "role" },
        { text: "Terms?", value: "terms", align: "center", sortable: false },
        { text: "Check-in", value: "terms", align: "center", sortable: false },
        { text: "", value: 'name', align: "center", sortable: false }
      ],
      useAltHeaders: false,
      pagination: {
        rowsPerPage: 50
      },
      rules: {
        populated: [v => !!v || "This field is required."],
        email: [
          v => !!v || "Email is required.",
          v => /@/.test(v) || "Please enter a valid email."
        ]
      },
      editedSchool: {},
      editedPerson: {},
      defaultSchool: {
        id: null,
        school: null,
        district: null,
        state: null,
        extra_attributes: {}
      },
      defaultPerson: {
        id: null,
        email: null,
        name: null,
        address: null,
        role: null,
        phone: null,
        extra_attributes: {}
      },
      addPersonRegistration: null,
      addPersonMode: false,
      addDistrictSchoolEventId: null,
      districtSchoolDialog: false,
      newDistrict: null,
      newSchool: null
    };
  },
  computed: {
    checkinType() {
      return this.$route.meta.checkin ? this.$route.meta.checkin.toLowerCase() : 'event';
    },
    headers() {
      return (this.useAltHeaders) ? this.altHeaders : this.regHeaders;
    },
    innerHeaders() {
      return (this.useAltHeaders) ? this.altInnerHeaders : this.regInnerHeaders;
    },
    // Group events by open/closed and then sort within each group. Add a divider between.
    displayEvents() {
      var open = [];
      var closed = [];
      var all = [];

      if (this.events) {
        for (var i = 0; i < this.events.length; i++) {
          var event = this.events[i];
          if (event['open']) {
            open.push(event);
          } else {
            closed.push(event);
          }
        }

        open.sort(function (a, b) {
          var x = a['name'];
          var y = b['name'];
          return x === y ? 0 : x > y ? 1 : -1;
        });
        closed.sort(function (a, b) {
          var x = a['name'];
          var y = b['name'];
          return x === y ? 0 : x > y ? 1 : -1;
        });

        all = open.concat([{ divider: true }], closed);
      }

      return all;
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    showExtraValue(v) {
      if (v && v.hasOwnProperty('street') && v.hasOwnProperty('city') && v.hasOwnProperty('zip')) {
        return v.street + ', ' + v.city + ', ' + v.state + ' ' + v.zip;
      }

      return v;
    },
    loadRegistrants(e) {
      this.$http.get('events/' + e.id).then(
        response => {
          this.eventLoaded = true;
          this.currentEventId = e.id;
          this.currentEventTitle = e.name;
          this.useAltHeaders = ([3].includes(e.id)); // add single registrations here?
          this.registrants = response.body.data[0].registrations;

          if (e.district_alert) {
            this.$store.commit("updateMessage", {
              message: "District/School saved successfully!",
              snackbar: true
            });
          }
        },
        response => {
          this.$store.commit("updateMessage", {
            message: "Error getting registrants. Try one more time, then freakout!",
            snackbar: true
          });
        }
      )
    },
    exportRegistration() {
      var regType = (this.useAltHeaders) ? 'single' : '';
      this.$http.get('registrations/export/' + this.currentEventId + '/' + regType, { responseType: 'arraybuffer' }).then(
        response => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([response.body], { type: 'text/csv' })

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.download = this.currentEventTitle + ' Export.csv'
          link.click()
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data)
          }, 100)
        }
      );
    },
    checkIn(obj) {
      this.$http.put("registration/terms/" + obj.uuid, { attended: true }).then(response => {
        obj.attended = true;
        this.$store.commit("updateMessage", {
          message: "You have been checked in!",
          snackbar: true
        });
      });
    },
    addDistrictSchool(eventId) {
      this.addDistrictEventId = eventId;
      this.districtSchoolDialog = true;
    },
    saveDistrictSchool() {
      if (this.$refs.districtSchoolForm.validate()) {
        let data = {
          registration_event_id: this.addDistrictEventId,
          district: this.newDistrict
        }

        if (this.newSchool && this.newSchool.trim !== '') {
          data.school = this.newSchool;
        }

        this.$http.post("new_district_school", data).then(
          response => {
            this.loadRegistrants({ id: this.addDistrictEventId, district_alert: true });
            this.closeDistrictSchool();
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Error saving. Try one more time, then email support!",
              snackbar: true
            });
          }
        );
      }
    },
    closeDistrictSchool() {
      this.districtSchoolDialog = false;
      setTimeout(() => {
        this.$refs.districtSchoolForm.reset();
        this.newDistrict = "";
        this.newSchool = "";
      }, 300)
    },
    addPerson(registrationId) {
      this.addPersonRegistrationId = registrationId;
      this.addPersonMode = true;
      this.personDialog = true
    },
    editPerson(id1, id2) {
      this.addPersonMode = false;
      this.editedSchool = this.registrants.find(r => r.id === id1);
      this.editedPerson = this.editedSchool.registration_team_member.find(p => p.id === id2);

      if (this.editedPerson.extra_attributes.length === 0) {
        // This one's a doozy. I don't like using that check above (length === 0) but
        // that's what I'm getting to work.
        this.editedPerson.extra_attributes = {};
      }
      this.personDialog = true
    },
    savePerson() {
      if (!this.$refs.managePersonForm.validate()) {
        this.$store.commit("updateMessage", {
          message:
              "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
        return;
      }
      if (this.addPersonMode) {
        this.editedPerson.registration_id = this.addPersonRegistrationId;
        this.$http.post("registration_team_member", this.editedPerson).then(
          response => {
            this.registrants.find(r => r.id === this.addPersonRegistrationId).registration_team_member.push(response.body.data);
            this.$store.commit("updateMessage", {
              message: "Person saved successfully!",
              snackbar: true
            });
            this.closePerson()
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Error saving. Try one more time, then email support!",
              snackbar: true
            });
          })
      } else {
        this.$http.put("registration/terms/" + this.editedPerson.uuid, this.editedPerson).then(
          response => {
            this.closePerson()
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Error saving. Try one more time, then email support!",
              snackbar: true
            });
          })
      }
    },
    deletePerson(id1, id2) {
      this.editedSchool = this.registrants.find(r => r.id === id1);
      this.editedPerson = this.editedSchool.registration_team_member.find(p => p.id === id2);
      if (confirm('Are you sure you want to delete this person?')) {
        this.$http.delete('registration_team_member/' + this.editedPerson.id).then(
          response => {
            Sugar.Array.remove(this.editedSchool.registration_team_member, function(n) {
              return n['id'] === id2
            }
            );
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Error deleting. Try one more time, then email support!",
              snackbar: true
            });
          }
        )
      }
    },
    closePerson() {
      this.personDialog = false
      this.addPersonMode = false
      setTimeout(() => {
        this.editedPerson = Object.assign({}, this.defaultPerson)
        //  this.editedIndex = -1
      }, 300)
    },
    editSchool(id1) {
      this.editedSchool = this.registrants.find(r => r.id === id1);

      if (this.editedSchool.extra_attributes.length === 0) {
        // This one's a doozy. I don't like using that check above (length === 0) but
        // that's what I'm getting to work.
        this.editedSchool.extra_attributes = {};
      }
      this.schoolDialog = true
    },
    saveSchool() {
      this.$http.put("registration/" + this.editedSchool.id, this.editedSchool).then(
        response => {
          this.closeSchool()
        },
        response => {
          this.$store.commit("updateMessage", {
            message: "Error saving. Try one more time, then freakout!",
            snackbar: true
          });
        })
    },
    deleteSchool(id1) {
      this.editedSchool = this.registrants.find(r => r.id === id1);
      if (confirm('Are you sure you want to delete this School?')) {
        this.$http.delete('registration/' + this.editedSchool.id).then(
          response => {
            Sugar.Array.remove(this.registrants, function(n) {
              return n['id'] === id1
            }
            );
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Error deleting. Try one more time, then freakout!",
              snackbar: true
            });
          }
        )
      }
    },
    closeSchool() {
      this.schoolDialog = false
      setTimeout(() => {
        this.editedSchool = Object.assign({}, this.defaultSchool)
        // this.editedIndex = -1
      }, 300)
    }
  },
  mounted() {
    const req = "events" + (this.checkinType === 'network' ? "?component=network" : null);

    this.$http.get(req).then(
      response => {
        this.eventsLoading = false;
        this.events = response.body.data;
      },
      response => {
        this.$store.commit("updateMessage", {
          message: "Error getting events. Try one more time, then freakout!",
          snackbar: true
        });
      }
    )
  }
};
</script>
